import React, { useEffect, useState } from 'react'
import { LoadingComponent } from '@pga/pga-component-library'
import { withRouter } from 'react-router-dom'
import algoliasearch from 'algoliasearch'
import { compose, isEmpty } from 'ramda'
import mapFromAlgolia from '../../job-posting/JobDetailPage/mapFromAlgolia'
import { ErrorBox } from './ErrorScreen'

export const GetSingleJob = props => {
  const { Component, error, currentJob, match } = props
  const currentPath = match.path.split('/')[1]
  const isCopy = currentPath === 'copy'
  const isEdit = currentPath === 'edit'
  const isEditOrCopy = isEdit || isCopy

  if (!currentJob) return <LoadingComponent />
  if (!isEmpty(currentJob) && !error) {
    const job = mapFromAlgolia(currentJob, isEditOrCopy)
    return (
      <Component editJob={isEditOrCopy && job} job={job} {...props} />
    )
  } else {
    return <ErrorBox global />
  }
}

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_API_KEY
)

const initIndex = () => searchClient.initIndex(process.env.REACT_APP_ALGOLIA_INDEX_NAME)

export const GetJob = props => {
  const [currentJob, setJob] = useState(null)
  const [error, setError] = useState(null)
  useEffect(() => {
    const getJob = async () => {
      const id = props.match.params.id
      try {
        const { hits } = await initIndex().search('', { filters: `jobId:${id}` })
        hits.length ? setJob(hits[0]) : setJob({})
      } catch (e) {
        setError(e)
      }
    }
    getJob()
  }, [])
  return <GetSingleJob {...{ currentJob, error }} {...props} />
}

export default compose(
  withRouter
)(GetJob)
